import { useState } from 'react'
import { useEffect } from 'react'

import Dialog from '../../../components/ReusableComponents/Dialog/index'
import brandColors from '../../../main/hotelBrandColors.json'
import { subChains } from '../../../main/hotelBrandsAndChains'
import { getHotelLevelBrandOverride } from '../../../utils/hotelBrandOverride'
import styles from './ChainLogo.module.scss'

const BRANDS_LOGO_URL = 'https://cdn.swaypay.io/logos/brands/'
const INDEPENDENT_LOGO_URL = 'https://cdn.swaypay.io/logos/independents/'

const ChainLogo = ({
  parentChainCode,
  chainCode,
  className,
  brand,
  setBrand,
  setChainCode,
  hotelIdentifier
}) => {
  const [errored, setErrored] = useState()
  const [subBrands, setSubBrands] = useState([])

  const hotelOverride = getHotelLevelBrandOverride(
    brandColors.hotelOverrides,
    chainCode,
    hotelIdentifier
  )

  useEffect(() => {
    setBrand(null)
    setSubBrands([])
    setErrored(false)
  }, [parentChainCode, chainCode, setBrand])

  useEffect(() => {
    if (parentChainCode === 'choice' && subChains[chainCode]) {
      setSubBrands(subChains[chainCode])
    } else {
      setBrand(chainCode)
    }
  }, [chainCode, parentChainCode, setBrand, subBrands])

  if (!brand && subBrands.length === 0) {
    return null
  }

  function handleSubBrandClick(subBrand) {
    setBrand(subBrand)
    setChainCode(subBrand)
  }

  const logoSrc = hotelOverride
    ? INDEPENDENT_LOGO_URL + hotelOverride.logoKey + '.png'
    : BRANDS_LOGO_URL + brand + '.png'

  const primaryColor =
    hotelOverride?.colors?.primary ||
    (brandColors?.[parentChainCode]?.[brand]
      ? brandColors[parentChainCode][brand].primary
      : brandColors.fallback.primary)

  return (
    <div
      className={className}
      style={{
        background: primaryColor
      }}
    >
      <div className={styles.container}>
        {brand && !errored && (
          <img
            onError={() => setErrored(true)}
            src={logoSrc}
            alt={hotelOverride ? hotelOverride.logoKey : brand}
          />
        )}
        {subBrands.length > 0 && !brand && (
          <Dialog>
            <div
              className={styles.dialog}
              style={{
                background: brandColors?.[parentChainCode]?.[subChains[chainCode][0]]
                  ? brandColors[parentChainCode][subChains[chainCode][0]].primary
                  : brandColors.fallback.primary
              }}
            >
              <div className={styles.dialogTitle}>Select brand logo</div>
              {subBrands.map(s => (
                <button key={s} onClick={() => handleSubBrandClick(s)}>
                  <img src={BRANDS_LOGO_URL + s + '.png'} alt={s} />
                </button>
              ))}
            </div>
          </Dialog>
        )}
      </div>
    </div>
  )
}

export default ChainLogo
